module.exports = __webpack_public_path__ + "img/palm1_3.c8b5f339.png";